export const calculatorsData = [
  {
    id: 1,
    calculatorName: "Personal Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/ptbt-1738411759551.webp",
    link: "/calculators/balance-transfer-calculators/personal-loan-balance-transfer-calculator",
  },
  {
    id: 2,
    calculatorName: "Home Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/htbt-1738411892022.webp",
    link: "/calculators/balance-transfer-calculators/home-loan-balance-transfer-calculator",
  },
  {
    id: 3,
    calculatorName: "Car Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/ctbt-1738414538742.webp",
    link: "/calculators/balance-transfer-calculators/car-loan-balance-transfer-calculator",
  },
];
